export const cleanPhoneNumber = (phone, countryCode) => {
    if (!phone) {
        return ''
    }
    if (!countryCode) {
        return phone
    }

    phone = phone.trim()
    const startsWithZeroZero = phone.startsWith('00')
    const startsWithPlus = phone.startsWith('+')

    phone = phone.replace(/[^0-9]/g, '')
    phone = phone.replace(/\s/g, '')

    if (startsWithZeroZero) {
        return '+' + phone.substring(2)
    }

    if (startsWithPlus) {
        return '+' + phone
    }

    return getCountryPrefix(countryCode) + phone
}

const getCountryPrefix = (countryCode) => {
    switch (countryCode) {
        case 'AT':
            return '+43'
        case 'CH':
            return '+41'
        case 'DE':
            return '+49'
        case 'GB':
            return '+44'
        default:
            return ''
    }
}




// WEBPACK FOOTER //
// ./src/util/clean-phone-number.js